<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>THE STORY DEVOTIONAL</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="ct1p" id="p0019-01-0"><a id="page13"></a><a href="#/contents#fn_12" id="sn_12">DAY 12</a></p>
<p class="ct1"><a href="#/contents#fn_12">BEFORE THEY ATE—AND AFTER</a></p>
<p class="ext"><span><i>The man and his wife heard the sound of the L<span class="small">ORD</span> God as he was walking in the garden in the cool of the day, and they hid from the L<span class="small">ORD</span> God among the trees of the garden. But the L<span class="small">ORD</span> God called to the man, “Where are you?”</i></span></p>
<p class="txr"><span><span class="small">GENESIS</span> 3:8–9</span></p>
<p class="tx1" id="p0019-04-4"><span class="dcap"><i>B</i></span><i>efore</i> Adam and Eve ate the fruit, fellowship with each other was easy, comfortable, free of any type of barrier because they were free of sin. Their privileged fellowship with the Lord was open, relaxed, life-giving, satisfying. He had given them this beautiful garden home, and he was meeting all their needs. Why would they want anything else?</p>
<p class="tx">But <i>after</i> Adam and Eve acted in order to be like God—to be independent, on their own, instead of dependent on him—the hiding and the blame began.</p>
<p class="tx">The two hid from each other behind coverings made of fig leaves. And the two hid from God.</p>
<p class="tx">The man blamed not only the woman but also God himself who had “put her with me.” The woman blamed the serpent’s deception. </p>
<p class="tx">The sweet fellowship of God, man, and woman had been shattered when they embraced sin rather than their Creator. Yet God did not turn his back on them.</p>
<p class="tx3">WHATEVER YOUR FELLOWSHIP-SHATTERING SIN, GOD WILL NOT TURN HIS BACK ON YOU.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter15.vue?9b9dfc9c